import { render, staticRenderFns } from "./MdnTreeView.vue?vue&type=template&id=33274f8f&scoped=true&"
import script from "./MdnTreeView.vue?vue&type=script&lang=js&"
export * from "./MdnTreeView.vue?vue&type=script&lang=js&"
import style0 from "./MdnTreeView.vue?vue&type=style&index=0&id=33274f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33274f8f",
  null
  
)

export default component.exports